import React from 'react';
import { motion } from 'framer-motion';

// React Bits "Pill Nav" (https://reactbits.dev/components/pill-nav) adapted as a tab
// group: a pill rail where the active item is a filled pill that slides between
// options (framer layoutId), with a hover fill on the rest.
const PillNav = ({
  items, activeIndex, onChange, accent = '#15171c',
}) => (
  <div
    style={{
      display: 'inline-flex',
      gap: 4,
      padding: 4,
      borderRadius: 999,
      background: '#f2f4f7',
      border: '1px solid #d0d5dd',
    }}
  >
    {items.map((label, i) => {
      const active = i === activeIndex;
      return (
        <button
          key={label}
          type="button"
          onClick={() => onChange(i)}
          style={{
            position: 'relative',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            padding: '9px 18px',
            borderRadius: 999,
            fontFamily: "'Montserrat', sans-serif",
            fontSize: 13.5,
            fontWeight: 600,
            color: active ? '#fff' : '#6b7280',
            transition: 'color 0.2s ease',
            whiteSpace: 'nowrap',
          }}
        >
          {active && (
            <motion.span
              layoutId="pillnav-active"
              style={{
                position: 'absolute',
                inset: 0,
                borderRadius: 999,
                background: accent,
                boxShadow: '0 4px 12px rgba(21,23,28,0.28)',
                zIndex: 0,
              }}
              transition={{ type: 'spring', stiffness: 400, damping: 32 }}
            />
          )}
          <span style={{ position: 'relative', zIndex: 1 }}>{label}</span>
        </button>
      );
    })}
  </div>
);

export default PillNav;
